module.exports = __webpack_public_path__ + "static/media/03.ab7662de.jpg";